// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';
import { TBiometricData, TProfileInfo, TShooterProfileInfo } from '../../types';

const initialState: IRootState = {
  profile_info: {} as TShooterProfileInfo | TProfileInfo,
  auth_info: {
    access_token: '',
    user_id: 0,
    user_type: '',
    role: '',
    account_type: '',
    token_type: '',
  },
  biometric_data_info: {} as TBiometricData,
};

export const slice = createSlice({
  name: STORE_SLICES.PROFILE_DATA,
  initialState,
  reducers,
});

const profileDataActions = slice.actions;

const profileDataDataPersistConfig = {
  key: PERSIST_KEYS.PROFILE_DATA,
  storage,
  whitelist: ['auth_info', 'profile_info', 'biometric_data_info'],
};

export { profileDataActions, initialState };
export default persistReducer(profileDataDataPersistConfig, slice.reducer);
